import { Intent } from "@blueprintjs/core";
import { DataTable, FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ConseillerPedagogiqueMetierLiesSearch, ConseillerPedagogiqueMetiersLiesApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { EditButton } from "../../../../../components";
import { useTl } from "../../../../../hooks";
import { useApiService } from "../../../../../hooks/useApiService";
import { ETLCodes } from "../../../../../locales";

export interface IConseillerPedagogiqueMetiersLiesProps {}

export const ConseillerPedagogiqueMetiersLies: React.FunctionComponent<IConseillerPedagogiqueMetiersLiesProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(ConseillerPedagogiqueMetiersLiesApi);
  const { id } = useParams<{ id: string }>();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { code: "ASC" }
  });

  const { totalCount } = tableState;
  const searchFunction = React.useCallback(
    (sObj?: ConseillerPedagogiqueMetierLiesSearch) => {
      sObj.idConseiller = id;
      return api.conseillerPedagogiqueMetiersLiesBaseSearch({ ConseillerPedagogiqueMetierLiesSearch: sObj });
    },
    [api, id]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Code),
        fieldName: "code",
        autoFitContent: true
      },
      {
        header: () => t(ETLCodes.Stade),
        fieldName: "stade"
      },
      {
        header: () => t(ETLCodes.Metier),
        fieldName: "metier"
      }
    ],
    [t]
  );

  return (
    <FieldSet
      title={t(ETLCodes.TableResults, { count: totalCount })}
      rightElement={
        <EditButton
          onClick={() => history.push(`${ERoutes.conseillerPedagogique}/${id}/metiersLies/selector`)}
          intent={Intent.PRIMARY}
          text={t(ETLCodes.Modify)}
        />
      }
    >
      <DataTable
        dateFormat="dd/MM/yyyy"
        tableState={tableState}
        loading={loading}
        columns={columns}
        filterMode="OnEnter"
      ></DataTable>
    </FieldSet>
  );
};
